<script setup lang="ts">
import { computed } from 'vue'
import { icons } from 'lucide-vue-next'
import { cn } from '@/lib/utils'

const props = withDefaults(defineProps<{
  name: string
  class?: string
  size?: number
}>(), {
  size: 16,
})

function toPascalCase(kebab: string): string {
  return kebab
    .split('-')
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join('')
}

const iconComponent = computed(() => {
  if (!props.name) return undefined
  return icons[toPascalCase(props.name) as keyof typeof icons]
})
</script>

<template>
  <component
    v-if="iconComponent"
    :is="iconComponent"
    :class="cn(props.class)"
    :size="props.size"
  />
</template>
